import * as React from 'react';
import {
  IconButton,
  Typography,
  Menu,
  Avatar,
  MenuItem,
  alpha,
  useTheme,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

// MESSAGES
import HomeFormattedMessages from '../../messages/HomeFormattedMessages';

// ICONS
import AccountIcon from '../icons/AccountIcon';

export default function AccountMenu({
  accessLevel,
  accessType,
  account,
  navBarInfo,
  handleImitationClear,
  handleLogout,
}) {
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const theme = useTheme();
  const menuRef = React.useRef(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const messages = {
    clearImitationText: (
      <FormattedMessage
        id="App.ClearImitationLink"
        defaultMessage="Clear Imitations"
      />
    ),
    logoutText: (
      <FormattedMessage id="App.LogoutLink" defaultMessage="Logout" />
    ),
  };

  return (
    <React.Fragment>
      <Typography
        sx={{
          color: !anchorElUser ? 'primary.main' : 'secondary.main',
          display: { xs: 'none', lg: 'block' },
          cursor: 'pointer',
        }}
        fontWeight={700}
        onClick={() => menuRef.current?.click()}
      >
        {navBarInfo.userEmail}
      </Typography>

      <IconButton
        ref={menuRef}
        onClick={handleOpenUserMenu}
        sx={{ padding: 0 }}
      >
        <Avatar
          sx={{
            color: !anchorElUser ? 'primary.main' : 'secondary.main',
          }}
        >
          <AccountIcon
            sx={{
              width: '100%',
              height: '100%',
            }}
          />
        </Avatar>
      </IconButton>

      <Menu
        sx={{
          '& .MuiList-root': {
            padding: 0,
          },
          '& .MuiMenuItem-root:nth-of-type(odd):not(:hover):not(:focus)': {
            backgroundColor: alpha(theme.palette.secondary.light, 0.15),
          },
          '& .Mui-disabled, & .Mui-disabled:nth-of-type(odd):not(:hover):not(:focus)':
            {
              opacity: 1,
              backgroundColor: 'secondary.main',
            },
          '& .MuiMenuItem-root': {
            justifyContent: 'flex-end',
          },
        }}
        id="menu-account"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <MenuItem disabled>
          <Typography sx={{ color: 'common.white' }}>
            <strong>{HomeFormattedMessages.accountTitleText}:</strong>
            {` ${account.customer_name}`}
          </Typography>
        </MenuItem>

        <MenuItem disabled>
          <Typography sx={{ color: 'common.white' }}>
            <strong>{HomeFormattedMessages.accountTitleText} #:</strong>
            {` ${navBarInfo.customerAccountNo}`}
          </Typography>
        </MenuItem>

        {navBarInfo.dedicatedNumbers &&
          navBarInfo.dedicatedNumbers.length > 0 && (
            <MenuItem
              disabled
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
              }}
            >
              <Typography
                sx={{
                  color: 'common.white',
                }}
              >
                <strong>{HomeFormattedMessages.dedicatedNumbers}:</strong>
              </Typography>
              {navBarInfo.dedicatedNumbers.map((number, index) => (
                <Typography
                  key={`dedicated_${index}`}
                  sx={{
                    color: 'common.white',
                  }}
                >
                  {number}
                </Typography>
              ))}
            </MenuItem>
          )}

        {accessLevel === '3' && accessType === '3' && (
          <MenuItem onClick={handleImitationClear}>
            <Typography
              fontWeight={700}
              sx={{ textDecoration: 'underline', color: 'secondary.main' }}
            >
              {messages.clearImitationText}
            </Typography>
          </MenuItem>
        )}

        <MenuItem onClick={handleLogout}>
          <Typography
            fontWeight={700}
            sx={{ textDecoration: 'underline', color: 'secondary.main' }}
          >
            {messages.logoutText}
          </Typography>
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
